var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 48,
    viewBox: "0 0 160 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_203)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1603_203",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 9,
    width: 69,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 9H114V39H45V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1603_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.251 9.7514H45.7485V38.2486H113.251V9.7514Z",
    stroke: "#737373",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2051 30.1674C59.4981 30.1701 58.7977 30.0316 58.1449 29.7601C57.4921 29.4885 56.8999 29.0893 56.4031 28.5858C55.905 28.0821 55.5119 27.4844 55.2465 26.8274C54.9811 26.1703 54.8488 25.467 54.8572 24.7584C54.8572 21.3258 57.7315 19.3095 60.3068 19.3095C62.1489 19.3095 63.8718 20.003 64.7932 21.6216L63.0703 22.6291C62.773 22.1775 62.3675 21.8075 61.8908 21.5528C61.4141 21.2981 60.8813 21.1668 60.341 21.1709C58.8258 21.1709 57.022 22.364 57.022 24.7284C57.022 27.0398 58.7449 28.304 60.4769 28.304C61.0575 28.298 61.6256 28.1339 62.1201 27.8293C62.6147 27.5248 63.0171 27.0912 63.2843 26.5751L65.0462 27.3984C64.0537 29.2033 62.2737 30.1674 60.2051 30.1674ZM71.4151 28.2119C73.3799 28.2119 74.7313 26.7328 74.7313 24.7444C74.7313 22.7561 73.3792 21.277 71.4151 21.277C69.4504 21.277 68.0522 22.7379 68.0522 24.7116C68.0522 26.7119 69.4065 28.2119 71.4151 28.2119ZM71.2074 30.1674C68.0962 30.1674 65.8805 27.8023 65.8805 24.7374C65.8805 21.6119 68.0759 19.3095 71.2074 19.3095C72.6446 19.3095 74.0288 19.9179 74.6923 20.8514V19.5781H76.8201V29.8786H74.6923V28.6019C73.9946 29.5298 72.6425 30.1674 71.2074 30.1674ZM87.5709 29.8744V21.5679H85.933V19.5098H87.5918V16.4658H89.7845V19.5105H92.0573V21.5679H89.7845V29.873H87.5709V29.8744ZM98.3321 28.2119C100.296 28.2119 101.65 26.7328 101.65 24.7444C101.65 22.7561 100.296 21.277 98.3314 21.277C96.3673 21.277 94.972 22.7379 94.972 24.7116C94.972 26.7119 96.3241 28.2119 98.3321 28.2119ZM98.1244 30.1674C95.0103 30.1674 92.7996 27.8023 92.7996 24.7374C92.7996 21.6119 94.9922 19.3095 98.1244 19.3095C99.5616 19.3095 100.946 19.9179 101.609 20.8514V19.5781H103.739V29.8786H101.609V28.6019C100.912 29.5298 99.5595 30.1674 98.1244 30.1674ZM79.0121 29.8619V19.5614H81.0396V21.3509C81.4585 20.1949 82.345 19.3974 83.5201 19.3974C83.7752 19.3926 84.0296 19.4212 84.2777 19.4812V21.473C82.6238 21.2812 81.2257 22.4421 81.2257 25.0933V29.8619H79.0121Z",
    fill: "#737373"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 30,
    fill: "white",
    transform: "translate(45 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarta);
export default __webpack_public_path__ + "static/media/carta.362a9cb164adcc877f3377879f704d95.svg";
export { ForwardRef as ReactComponent };